import type { CaseItem } from "../../../../packages/core/src/types";
export type LastVisit={at:string;areaIds:string[]};
export function visitDigest(last:LastVisit|null,items:readonly CaseItem[],closedIds:readonly string[],watchIds:readonly string[]){
 if(!last||!Number.isFinite(Date.parse(last.at)))return null;
 const seen=new Set(last.areaIds);const watching=new Set(watchIds);
 return {newCount:items.filter(i=>!seen.has(i.id)&&i.publishedAt&&Date.parse(i.publishedAt)>Date.parse(last.at)).length,closedCount:closedIds.filter(id=>watching.has(id)||seen.has(id)).length};
}
